export default __webpack_public_path__ + "static/media/BirdPage1.867dde3c.txt";